export const transient = {shouldForwardProp: (prop: string) => !prop.startsWith('$') && prop !== 'as'};